import apiClient from "../lib/api-client";

function mutationHeaders() {
  return { headers: { "Idempotency-Key": crypto.randomUUID() } };
}

export interface Counter {
  id: string;
  tenantId: string;
  storeId: string;
  name: string;
  code?: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  store?: {
    id: string;
    name: string;
  };
}

export interface CreateCounterDto {
  storeId: string;
  name: string;
  code?: string;
  status?: string;
}

export interface UpdateCounterDto extends Partial<CreateCounterDto> {}

export interface CounterListResponse {
  data: Counter[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const counterService = {
  async getCounters(params?: {
    page?: number;
    limit?: number;
    storeId?: string;
  }): Promise<CounterListResponse> {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append("page", params.page.toString());
    if (params?.limit) searchParams.append("limit", params.limit.toString());
    if (params?.storeId) searchParams.append("storeId", params.storeId);
    const response = await apiClient.get(`/counters?${searchParams}`);
    return response.data;
  },

  async getCounter(id: string): Promise<Counter> {
    const response = await apiClient.get(`/counters/${id}`);
    return response.data;
  },

  async createCounter(data: CreateCounterDto): Promise<Counter> {
    const response = await apiClient.post("/counters", data, mutationHeaders());
    return response.data;
  },

  async updateCounter(id: string, data: UpdateCounterDto): Promise<Counter> {
    const response = await apiClient.patch(
      `/counters/${id}`,
      data,
      mutationHeaders(),
    );
    return response.data;
  },

  async deleteCounter(id: string): Promise<void> {
    await apiClient.delete(`/counters/${id}`, mutationHeaders());
  },
};
